define(function () {
  return {
    // CALL CENTER USER
    'call_center.register': "Εγγραφή άλλου χρήστη",

    'incrowd_stats.num_responders': "{{num}} Ειδικοί Επαγγελματίες στην Ιατροφαρμακευτική Περίθαλψη",
    'incrowd_stats.num_answers': "{{num}} Ερωτήσεις Απαντήθηκαν",
    'incrowd_stats.time_to_complete': "{{num}} Λεπτά για να Ολοκληρώσετε Κατά Μέσο Όρο την Έρευνα",

    // INCROWD
    'incrowd.about': "Σχετικά",
    'incrowd.contact': "Επικοινωνία",
    'incrowd.press': "Τύπος",
    'incrowd.careers': "Θέσεις εργασίας",
    'incrowd.terms': "Όροι",
    'incrowd.t_and_c': "Όροι και Προϋποθέσεις",
    'incrowd.faq': "Συχνές Ερωτήσεις",
    'incrowd.privacy': "Προστασία Δεδομένων",
    'incrowd.copyright': "{{year}} InCrowd Inc, Με επιφύλαξη παντός δικαιώματος",
    'incrowd.blog': "Ιστολόγιο",
    'incrowd.support': "Υποστήριξη",
    'incrowd.info.ios': "Γνωρίζατε ότι οι γιατροί στο δίκτυο InCrowd μπορούν τώρα να στείλουν ερωτήσεις απ 'ευθείας στους συναδέλφους τους; Δοκιμάστε το τώρα, χρησιμοποιώντας την <InCrowd iOS Εφαρμογή>!",
    'incrowd.refer': "Σας αρέσουν οι έρευνές μας; <Συστήστε ένα φίλο> σήμερα να ενταχθεί στον κόσμο μας και θα κερδίσετε και οι δύο 10 USD (ή ισοδύναμο). Μόλις ένας συνάδελφός σας απαντήσει σε μια έρευνα, θα λάβει επίσης ένα μπόνους!",


    // GET STARTED (step 0)
    'getstarted.encourage.title': "Μικρό-έρευνες,",
    'getstarted.encourage.title.two': "Μαζική Επιρροή",
    'getstarted.encourage.subtitle': "Συμμετάσχετε με χιλιάδες εξειδικευμένο ιατρικό προσωπικό που επηρεάζουν την ανάπτυξη νέων φαρμάκων και θεραπειών των ασθενών μέσω απλών μικρο-ερευνών, και επίσης σας πληρώνουμε!",
    'getstarted.encourage.redirect_to_solutions': "Δεν είστε επαγγελματίας στην ιατροφαρμακευτική περίθαλψη αλλά θέλετε να μάθετε περισσότερα για το InCrowd;",
    'getstarted.actions.title': "Είστε ένας ειδικευμένος επαγγελματίας γιατρός;",
    'getstarted.actions.subtitle': "Εγγραφείτε σήμερα και αρχίστε να κερδίζετε χρήματα απαντώντας για την υγειονομική περίθαλψη που επικεντρώνονται σε μικρο-έρευνες",
    'getstarted.button.continue': "Ξεκινήστε",
    'getstarted.referral': "Εγγραφείτε για να κερδίσετε χρήματα από τις έρευνες συν το μπόνους παραπομπής σας από τον/την % {{referrerName}}",
    'getstarted.complete_registration': " Complete your InCrowd registration and start receiving surveys today!",
    'getstarted.questions': "Have questions? Use the chat box on the bottom right of the screen, we're here to help.",

    'details.need_info_description': "Χρειαζόμαστε μερικές λεπτομέρειες από εσάς για να ρυθμίσουμε τον λογαριασμό σας.",
    'details.profile_details': "Λεπτομέρειες για το Προφίλ",
    'details.address_information': "Πληροφορίες για την Διεύθυνση",
    'details.professional_info': "Επαγγελματικές Πληροφορίες",
    'details.heading.finally': "…και τελικά",
    'details.how_receive_surveys': "Πώς θέλετε να λαμβάνετε έρευνες;",

    // PROFESSION CHOICE (step 1)
    'professionchoice.encourage.title': "Τα βασικά",
    'professionchoice.encourage.subtitle': "Δεν βλέπετε το επάγγελμα σας; Ενημερώστε μας <εδώ> για να διασφαλίσουμε ότι θα ειδοποιηθείτε όταν προσθέσουμε το επάγγελμα σας.",
    // AUTHENTICATION INFORMATION (step 2)
    'authentication.encourage.title': "Ποιος είστε;",
    'authentication.encourage.subtitle': "Η InCrowd πρέπει να επαληθεύσει την ταυτότητα σας, αλλά εμείς ποτέ δεν θα αποκαλύψουμε ή θα διακινήσουμε τα προσωπικά σας στοιχεία σε τρίτους.",
    'authentication.actions.select_notifications': "Επιλέξτε πώς θέλετε να λαμβάνετε έρευνες από εμάς",
    // VALIDATE IDENTITY (step 3)
    'validation.please_wait': "Παρακαλούμε περιμένετε όσο επικυρώνουμε τις πληροφορίες σας",
    'validation.please_answer': "Παρακαλούμε απαντήστε στις ακόλουθες ερωτήσεις για να μας βοηθήσετε να επικυρώσουμε τα προσωπικά σας στοιχεία",
    // CONFIRMATION (final step)
    'confirmation.validation_success.title': "Επιβεβαίωση",
    'confirmation.validation_success.subtitle': "Η εγγραφή σας ολοκληρώθηκε, καλωσορίσατε στο InCrowd! Θα λάβετε επιβεβαίωση σύντομα μέσω email και/ή γραπτού μηνύματος. Ευχαριστούμε για την εγγραφή!",
    'confirmation.validation_error.title': "Απαιτούνται Επιπλέον Πληροφορίες",
    'confirmation.validation_error.subtitle': "Λυπάμαι %{userFirstName}, υπήρξε ένα πρόβλημα κατά την επικύρωση των προσωπικών σας στοιχείων.",
    'confirmation.actions_title': "Τι ακολουθεί;",
    'confirmation.go_to_your_profile': "Μετάβαση στο προφίλ σας",
    'confirmation.validation_success.actions_subtitle': "Θα αρχίσετε να λαμβάνετε τις μικρο-έρευνές μας διάρκειας 3 -5 λεπτών σε μερικές ημέρες μέσω e-mail ή γραπτού μηνύματος. Δεν δηλώσατε συμμετοχή στη λήψη ερευνών μέσω γραπτού μηνύματος ακόμα; Μπορείτε να αλλάξετε τις ρυθμίσεις της επικοινωνίας σας ανά πάσα στιγμή από το InCrowd προφίλ σας.",
    'confirmation.validation_error.actions_subtitle': "Παρακαλούμε χρησιμοποιήστε το αναδυόμενο παράθυρο συνομιλίας στην κάτω δεξιά γωνία της οθόνης για να μιλήσετε με ένα μέλος της ομάδας InCrowd και να θέσετε οποιαδήποτε θέματα.",
    'confirmation.referral.info.1': "Εντός %{payoutBusinessDays} εργάσιμων ημερών από την ολοκλήρωση της 2ης έρευνας, εσείς, και το πρόσωπο που σας ανέφερε, <θα λάβετε και οι δυο %{currency}%{referralBonusAmount}>. Τα %{currency}%{referralBonusAmount} θα προστεθούν στο λογαριασμό ανταμοιβών σας. Μπορείτε να συνδεθείτε στο λογαριασμό σας <profile> οποιαδήποτε στιγμή για να ενημερώσετε τις προτιμήσεις, να δείτε τις ανταμοιβές σας, ή να μπείτε σε όλες τις ανοιχτές έρευνες στις οποίες έχετε προσκληθεί.",
    'confirmation.referral.info.2': "Ερωτήσεις; <Συνομιλήστε μαζί μας>",

    // REGISTRATION FOOTER
    'regftr.qualified.title': "Πληρείτε τις προϋποθέσεις;",
    'regftr.markets.accepting': "H InCrowd Answers προς το παρόν δέχεται:",
    'regftr.peers.title': "Συνάδελφοι",
    'regftr.peers.subtitle': "Συγκρίνετε τις απαντήσεις σας με τις απαντήσεις από τους συναδελφους σας και μάθετε από τις απαντήσεις τους.",
    'regftr.invites.title': "Προσκλήσεις",
    'regftr.invites.subtitle': "Λάβετε νέες προσκλήσεις ερευνών μέσω email ή στο τηλέφωνο σας για να μεγιστοποιήσετε τα κέρδη σας.",
    'regftr.earnings.title': "Κέρδη",
    'regftr.earnings.subtitle': "Διαχειριστείτε και παρακολουθήστε τα κέρδη και τις πληροφορίες των πληρωμών σας.",
    'regftr.stats.title': "Στατιστικά",
    'regftr.stats.subtitle': "Αποκτήστε πρόσβαση σε ένα πίνακα πληροφοριών με όλα τα στοιχεία των ερευνών σας και τις πληροφορίες του χρήστη.",

    'contextual_help.sms': "Θα λάβετε μια ειδοποίηση μέσω SMS για τις διαθέσιμες μικροέρευνες. Μέσω των SMS θα έχετε γρηγορότερη πρόσβαση σε έρευνες και θα κερδίζετε περισσότερα βραβεία. Τα στοιχεία σας παραμένουν προστατευμένα και χρησιμοποιούνται μόνο για προσκλήσεις σε έρευνες.",
    'contextual_help.specialty': "Συμπεριλάβετε μόνο ειδικότητες που συνδέονται με το δικό σας NPI (Αναγνωριστικό Εθνικού Παρόχου Υγείας) , στις οποίες έχετε ολοκληρώσει υποτροφίες ή τομείς ιατρικής που εμπίπτουν στην κύρια ειδικότητά σας. Αν χρειαστεί να αλλάξετε τις ειδικότητες σας στο μέλλον, επικοινωνήστε με το support@incrowdnow.com.",
    // USER
    'user(s)': "Χρήστης |||| Χρήστες",
    'user.login': "Σύνδεση",
    'user.logout': "Αποσύνδεση",
    'user.register': "Εγγραφή",
    'user.invitations': "Προσκλήσεις",
    'user.email': "Email",
    'user.pass_word': "Κωδικός",
    'user.mobile': "Κινητό",
    'user.mobile.hint': "Παρακαλούμε να συμπεριλάβετε τον κωδικό της χώρας (+%{phoneCode} για %{countryName})",
    'user.title': "Τίτλος",
    'user.title_with_example': "Τίτλος (π.χ. Δρ., Κα., Κος.)",
    'user.first_name': "Όνομα",
    'user.last_name': "Επίθετο",
    'user.middle_name': "Μεσαίο όνομα",
    'user.full_name': "%{firstName} %{lastName}",
    'user.full_name_and_title': "%{title} %{firstName} %{lastName}",
    'user.first_name_last_initial': "%{firstName} %{lastInitial}.",
    'user.anonymous': "Χρήστης A",
    'user.anonymous_admin': "Διαχειριστής",
    'user.dashboard': "Πίνακας ελέγχου",
    'user.profile': "Προφίλ",
    'user.profile.picture.upload': "Μεταφόρτωση εικόνας προφίλ",
    'user.profile.picture.change': "Αλλαγή",
    'user.primary_lang': "Μητρική Γλώσσα",
    'user.primary_lang?': "Ποια είναι η μητρική σας γλώσσα;",
    'user.survey_langs?': "Ποιες γλώσσες μιλάτε άπταιστα;",
    'user.notify_email': "Ειδοποίηση μέσω Email",
    'user.notify_mobile': "Ειδοποίηση μέσω Κινητού",
    'user.contact_support': "Επικοινωνήστε με την Υποστήριξη",
    // SATURN-9
    'user.contact_trouble': "Having trouble? Contact us below:",
    'user.contact_email': "Send us an email",
    // end SATURN-9
    'user.please_contact_us': "Παρακαλούμε <επικοινωνήστε μαζί μας>.",
    'user.profession': "Επάγγελμα",
    'user.profession?': "Ποιο είναι το επάγγελμά σας;",
    'user.join_now': "Εγγραφή Τώρα",
    'user.welcome_back': "Καλώς ήρθατε και πάλι!",
    'user.not_a_member?': "Δεν είστε μέλος ακόμη;",
    'user.accept_terms': "Αποδοχή Όρων",
    'user.accept_terms.yes': "Αποδέχομαι τους <όρους και προϋποθέσεις>",
    'user.remember_me': "Απομνημόνευση σε αυτή την συσκευή",
    'user.time_zone': "Ζώνη Ώρας",
    'user.payment.policy': "Κάθε φορά που φτάνετε %{currency}25 σε ανταμοιβές θα ειδοποιείστε και θα μπορείτε να επιλέγετε από τις επιλογές πληρωμών μας μέσω του InCrowd προφίλ σας. Απορίες; Επικοινωνήσετε μαζί μας μέσω του παράθυρου συνομιλίας παρακάτω.",
    'user.country.live_work?': "Σε ποια χώρα ζείτε και εργάζεστε;",
    // FORMS
    'form.button.back': "Πίσω",
    'form.button.next': "Επόμενο",
    'form.button.cancel': "Ακύρωση",
    'form.button.submit': "Υποβολή",
    'form.button.continue': "Συνέχεια",
    'form.button.close': "Κλείσιμο",
    'form.button.go!': "Μετάβαση!",
    'form.button.complete!': "Ολοκλήρωση τώρα!",
    'form.button.update': "Ενημέρωση",
    'form.button.finish': "Ολοκλήρωση",
    'form.button.search': "Αναζήτηση",
    'form.button.end': "Τέλος",
    'form.search.no_matches': "Δεν βρέθηκαν εγγραφές",
    'form.confirm_email': "Επιβεβαίωση Email",
    'form.confirm_pass_word': "Επιβεβαίωση Κωδικού",
    'form.required_fields': "Υποχρεωτικά πεδία",
    'form.nothing_selected': "Κανένα επιλεγμένο",
    'form.confirm_field': "Επιβεβαίωση %{formFieldLabel}",
    'form.choice.n/a': "Δεν εφαρμόζεται",
    'form.choice.yes': "Ναι",
    'form.choice.no': "Όχι",
    'form.choice.blank_for_all': "Αφήστε κενό για να τα επιλέξετε όλα",
    'form.choices.select_all': "Επιλογή όλων",
    'form.choices.deselect_all': "Αποεπιλογή όλων",
    'form.field.private': "Ιδιωτικός τομέας",

    // USER ERRORS
  'user.error.dup_email': "Ένας άλλος χρήστης έχει ήδη εγγραφεί με τη συγκεκριμένη διεύθυνση ηλεκτρονικού ταχυδρομείου. <Συνδεθείτε αντ 'αυτού;>",
  'user.error.dup_sms': "Ένας άλλος χρήστης έχει ήδη καταχωρηθεί με τον συγκεκριμένο αριθμό τηλεφώνου",
  }
})
